export default __webpack_public_path__ + "static/media/review-tab-icon.13b04426.svg";